/**
 *  Point of contact for section components
 *
 *  ie: import { Example } from 'components/sections';
 *
 */

import AboutWithCoupon from './AboutWithCoupon/AboutWithCoupon';
import AboutWithPics from './AboutWithPics/AboutWithPics';
import AddOns from './AddOns/AddOns';
import Banner from './Banner/Banner';
import BasicHeader from './BasicHeader/BasicHeader';
import BigMap from './BigMap/BigMap';
import Blog from './Blog/Blog';
import Breadcrumbs from './Breadcrumbs/Breadcrumbs';
import ChildBlock from './ChildBlock';
import ContactFacility from './ContactFacility/ContactFacility';
import CTACustom from './CTACustom/CTACustom';
import CTAStockIcons from './CTAStockIcons/CTAStockIcons';
import Directions from './Directions/Directions';
import FacilityContactHours from './FacilityContactHours/FacilityContactHours';
import FacilitiesList from './FacilitiesList/FacilitiesList';
import FacilityGroupSection from './FacilityGroupSection/FacilityGroupSection';
import FacilityReviews from './FacilityReviews/FacilityReviews';
import FacilityUnits from './FacilityUnits/FacilityUnits';
import RentalApp from './RentalApp/RentalApp';
import Footer from './Footer/Footer';
import Header from './Header/Header';
import HeaderEmbed from './HeaderEmbed/HeaderEmbed';
import HeaderLogoNav from './HeaderLogoNav/HeaderLogoNav';
import HeaderTwoColumn from './HeaderTwoColumn/HeaderTwoColumn';
import HeaderWithTextbox from './HeaderWithTextbox/HeaderWithTextbox';
import LocationsNearYou from './LocationsNearYou/LocationsNearYou';
import PayOnline from './PayOnline/PayOnline';
import PicsWithAmenities from './PicsWithAmenities/PicsWithAmenities';
import Placeholder from './Placeholder/Placeholder';
import Preheader from './Preheader/Preheader';
import PreheaderText from './PreheaderText/PreheaderText';
import PreheaderTwoWidgets from './PreheaderTwoWidgets/PreheaderTwoWidgets';
import Privacy from './Privacy/Privacy';
import Reviews from './Reviews/Reviews';
import SimpleDividerLine from './SimpleDividerLine';
import SimpleFooter from './SimpleFooter/SimpleFooter';
import SimpleHeader from './SimpleHeader/SimpleHeader';
import SimpleHero from './SimpleHero/SimpleHero';
import SimpleHeroSlideShow from './SimpleHeroSlideShow/SimpleHeroSlideShow';
import SingleColumnWithBorder from './SingleColumnWithBorder/SingleColumnWithBorder';
import StackingThreeColumn from './StackingThreeColumn/StackingThreeColumn';
import StorageCalculator from './StorageCalculator/StorageCalculator';
import TermsAndConditions from './TermsAndConditions/TermsAndConditions';
import ThreeColumn from './ThreeColumn/ThreeColumn';
import TwoColumn from './TwoColumn/TwoColumn';
import TwoColumnHeaderRight from './TwoColumnHeaderRight/TwoColumnHeaderRight';
import TwoColumnHeaderLeft from './TwoColumnHeaderLeft/TwoColumnHeaderLeft';
import UnitSizes from './UnitSizes/UnitSizes';

const sections = {
  AboutWithCoupon,
  AboutWithPics,
  AddOns,
  Banner,
  BasicHeader,
  BigMap,
  Blog,
  Breadcrumbs,
  ChildBlock,
  ContactFacility,
  CTACustom,
  CTAStockIcons,
  Directions,
  FacilityContactHours,
  FacilitiesList,
  FacilityGroupSection,
  FacilityReviews,
  FacilityUnits,
  RentalApp,
  Footer,
  Header,
  HeaderEmbed,
  HeaderLogoNav,
  HeaderTwoColumn,
  HeaderWithTextbox,
  LocationsNearYou,
  PayOnline,
  PicsWithAmenities,
  Placeholder,
  Preheader,
  PreheaderText,
  PreheaderTwoWidgets,
  Privacy,
  Reviews,
  SimpleDividerLine,
  SimpleFooter,
  SimpleHeader,
  SimpleHero,
  SimpleHeroSlideShow,
  SingleColumnWithBorder,
  StackingThreeColumn,
  StorageCalculator,
  TermsAndConditions,
  ThreeColumn,
  TwoColumn,
  TwoColumnHeaderRight,
  TwoColumnHeaderLeft,
  UnitSizes,
};

const allSections = { ...sections };
export { sections, allSections, BasicHeader, SimpleFooter };
